<div class="input-container"
     [style.width.px]="width">
  <span class="country-code">TW +886</span>
  <input required autocomplete="off" #input type="tel" appAutoFocus class="phone"
         placeholder="請輸入手機號碼" i18n-placeholder
         [style.width.px]="width - inputBuffer"
         [attr.maxlength]="maxLength"
         [maxLength]="maxLength"
         [value]="value()"
         (input)="data.emit($any($event.target).value)">
  @if (input.value) {
    <button class="icon-clear" tabindex="-1" appFocusRemove
            (click)="input.value = '';data.emit('')">
      <app-image-loading src="assets/icon_circle_clear.svg" alt="清除" i18n-alt
                         [clickable]="true"
                         [targetWidth]="14"
                         [targetHeight]="14"/>
    </button>
  }
</div>
